import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import NotFoundMessage from "../../components/common/Modal/NotFoundMessage";
import LoadingComponent from "../../components/common/LoadingComponent";
import { Icons } from "../../constants/icon-library";
import { getOrganizationUsers } from "../../features/organization/organizationSlice";

function Users() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { users, loading } = useSelector((state) => state.organization);

  useEffect(() => {
    dispatch(getOrganizationUsers());
  }, [dispatch]);

  const showUsersNotFoundError = !loading && users.length === 0;

  return (
    <div className="content">
      <div className="d-flex flex-column pt-3">
        {!showUsersNotFoundError && (
          <div className="row">
            <div className="card border p-0">
              <div className="card-header p-4 py-3 border-bottom bg-body">
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="mb-0">Users</h3>
                  <button
                    className="btn btn-primary"
                    onClick={() => navigate("/users/create")}
                  >
                    <i
                      className={`wb ${Icons("add")} fs-8 me-2 align-middle`}
                    />
                    Add Setting
                  </button>
                </div>
              </div>

              <div className="card-body">
                {loading ? (
                  <LoadingComponent loading />
                ) : users.length === 0 ? (
                  <div className="text-danger">No users found.</div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-striped fs-9 mb-0">
                      <thead>
                        <tr>
                          <th className="border-top ps-3">Name</th>
                          <th className="border-top ps-3">Email</th>
                          <th className="border-top ps-3">Phone Number</th>
                          <th className="border-top ps-3">Role</th>
                          <th className="border-top">Created On</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[...users].reverse().map((u) => (
                          <tr key={u.uuid}>
                            <td className="align-middle ps-3">
                              {u.name || "-"}
                            </td>
                            <td className="align-middle ps-3">{u.email}</td>
                            <td className="align-middle ps-3">
                              {Array.isArray(u.phoneNumber) &&
                              u.phoneNumber.length > 0
                                ? u.phoneNumber.join(", ")
                                : "-"}
                            </td>

                            <td className="align-middle ps-3">
                              {Array.isArray(u.roles) && u.roles.length > 0
                                ? u.roles.map((r, idx) => (
                                    <span
                                      key={idx}
                                      className="badge bg-secondary me-1"
                                    >
                                      {r}
                                    </span>
                                  ))
                                : "-"}
                            </td>
                            <td className="align-middle">
                              {moment
                                .utc(u.createdAt)
                                .format("MMM D, YYYY • h:mm A")}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {showUsersNotFoundError && (
          <NotFoundMessage
            message="No users found. Add a user to get started."
            onAddNew={() => navigate("create")}
            buttonMessage="Add User"
          />
        )}
      </div>
    </div>
  );
}

export default Users;
